import React from "react";
import { components } from "../../../../../api/spec";

interface GuestListSectionProps {
  guests: components["schemas"]["EventAttendeeSummarySchema"][];
  selectedGuests: string[];
  onGuestToggle: (guestId: string) => void;
  searchQuery: string;
}

const GuestListSection: React.FC<GuestListSectionProps> = ({
  guests,
  selectedGuests,
  onGuestToggle,
  searchQuery,
}) => (
  <div>
    {guests.map((guest, index) => (
      <div
        key={guest.guid}
        role="button"
        tabIndex={0}
        onClick={() => onGuestToggle(guest.guid || "")}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onGuestToggle(guest.guid || "");
          }
        }}
        className={`flex items-center justify-between py-3 cursor-pointer hover:bg-white/5 ${
          index < guests.length - 1 ? "border-b border-white/10" : ""
        }`}
      >
        <div className="flex items-center space-x-3">
          <span className="text-white font-medium">{guest.full_name}</span>
          <span className="text-white/50 text-sm">{guest.gender}</span>
        </div>
        <div
          className={`w-4 h-4 border-2 rounded-sm flex items-center justify-center ${
            selectedGuests.includes(guest.guid || "")
              ? "border-white bg-black"
              : "border-white/30"
          }`}
        >
          {selectedGuests.includes(guest.guid || "") && (
            <div className="w-3 h-3 border border-black rounded-sm bg-white" />
          )}
        </div>
      </div>
    ))}

    {guests.length === 0 && (
      <div className="text-center py-8">
        <p className="text-white/60">
          {searchQuery
            ? "No guests found matching your search."
            : "No guests available"}
        </p>
      </div>
    )}
  </div>
);

export default GuestListSection;
